import '../stylesheets/about-me/about-me.css'


export default function AboutMe(){
    return(
        <section className="aboutMe" id="anchor-introduction">
            <div className="aboutMe-content">

                <p className='aboutMe-welcome'>Bienvenue,</p>
                <h1>Je suis <strong>Kélian</strong>
                    <br/>
                    Développeur Web Front-End Junior
                </h1>
                <p> Basé en Alpes-de-Haute-Provence, 
                    <br/>
                    Passionné d'informatique depuis mon enfance,
                    <br/>
                    Je me suis lancé dans une formation d'intégrateur web auprès d'OpenClassrooms afin d'en faire mon métier,
                    <br/>
                    Cherche toujours à m'améliorer et à enrichir mes connaissances sur le domaine 
                </p>
                </div>
        </section>

    )
    
}